import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box
} from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import moment from 'moment';

const WebsiteTable = ({ websites, onSelectWebsite, sortField, sortDirection, onSort }) => {
    const websiteList = websites?.results || [];

    const handleRowClick = (website, event) => {
        // Prevent default to avoid any unexpected behavior
        event.preventDefault();
        
        // Middle click or Ctrl/Cmd + click
        if (event.button === 1 || (event.button === 0 && (event.ctrlKey || event.metaKey))) {
            onSelectWebsite(website, true);
        } else if (event.button === 0) { // Left click only
            onSelectWebsite(website, false);
        }
    };

    const SortIcon = ({ field }) => {
        if (field !== sortField) return null;
        return sortDirection === 'asc' ? 
            <ArrowUpwardIcon fontSize="small" /> : 
            <ArrowDownwardIcon fontSize="small" />;
    };

    const renderSortableHeader = (field, label) => (
        <TableCell
            onClick={() => onSort(field)}
            style={{ cursor: 'pointer' }}
        >
            <Box display="flex" alignItems="center">
                {label}
                <Box ml={0.5}>
                    <SortIcon field={field} />
                </Box>
            </Box>
        </TableCell>
    );

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        {renderSortableHeader('domain', 'Domain')}
                        {renderSortableHeader('avg_daily_posts', 'Avg Daily Posts')}
                        {renderSortableHeader('last_checked', 'Last Checked')}
                        <TableCell>Profile Status</TableCell>
                        <TableCell>Robots.txt Status</TableCell>
                        <TableCell>Profile Error</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {websiteList.map((website) => (
                        <TableRow 
                            key={website.id} 
                            onClick={(e) => handleRowClick(website, e)}
                            onAuxClick={(e) => handleRowClick(website, e)}
                            style={{ cursor: 'pointer' }}
                            hover
                        >
                            <TableCell>{website.domain}</TableCell>
                            <TableCell>
                                {website.avg_daily_posts ? 
                                    Number(website.avg_daily_posts).toFixed(1) : 
                                    '0'}
                            </TableCell>
                            <TableCell>
                                {website.last_checked ? 
                                    moment(website.last_checked).format('YYYY-MM-DD') : 
                                    'Never'}
                            </TableCell>
                            <TableCell>{website.profile_status}</TableCell>
                            <TableCell>
                                {website.robots_txt_status ? 
                                    JSON.stringify(website.robots_txt_status) : 
                                    'N/A'}
                            </TableCell>
                            <TableCell>{website.profile_error || 'None'}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default WebsiteTable;